"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Menu"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12.666 2.66667C12.666 2.48986 12.5958 2.32029 12.4708 2.19526C12.3457 2.07024 12.1762 2 11.9993 2C11.8225 2 11.653 2.07024 11.5279 2.19526C11.4029 2.32029 11.3327 2.48986 11.3327 2.66667L11.3327 13.3333C11.3327 13.5101 11.4029 13.6797 11.5279 13.8047C11.653 13.9298 11.8225 14 11.9993 14C12.1762 14 12.3457 13.9298 12.4708 13.8047C12.5958 13.6797 12.666 13.5101 12.666 13.3333L12.666 2.66667ZM7.99935 2C8.17616 2 8.34573 2.07024 8.47075 2.19526C8.59578 2.32029 8.66602 2.48986 8.66602 2.66667L8.66602 13.3333C8.66602 13.5101 8.59578 13.6797 8.47075 13.8047C8.34573 13.9298 8.17616 14 7.99935 14C7.82254 14 7.65297 13.9298 7.52794 13.8047C7.40292 13.6797 7.33268 13.5101 7.33268 13.3333L7.33268 2.66667C7.33268 2.48986 7.40292 2.32029 7.52794 2.19526C7.65297 2.07024 7.82254 2 7.99935 2ZM3.99935 2C4.17616 2 4.34573 2.07024 4.47075 2.19526C4.59578 2.32029 4.66602 2.48986 4.66602 2.66667L4.66602 13.3333C4.66602 13.5101 4.59578 13.6797 4.47075 13.8047C4.34573 13.9298 4.17616 14 3.99935 14C3.82254 14 3.65297 13.9298 3.52794 13.8047C3.40292 13.6797 3.33268 13.5101 3.33268 13.3333L3.33268 2.66667C3.33268 2.48986 3.40292 2.32029 3.52794 2.19526C3.65297 2.07024 3.82254 2 3.99935 2Z",
    fill: fill
  })));
};

exports["default"] = _default;